export default "__VITE_ASSET__CMoGTuQS__"